export function toISODate(date) {
  const value = new Date(date);
  const offset = value.getTimezoneOffset();
  const local = new Date(value.getTime() - offset * 60 * 1000);
  return local.toISOString().split('T')[0];
}

export function addDays(date, days) {
  const value = new Date(date);
  value.setDate(value.getDate() + days);
  return value;
}

export function getTomorrowDate() {
  return toISODate(addDays(new Date(), 1));
}

export function getDefaultDropoffDate(pickupDate) {
  return toISODate(addDays(pickupDate || new Date(), 1));
}

export function getBookedFrom(item) {
  return item?.bookedFrom || item?.booked_from || item?.startDate || '';
}

export function getBookedFor(item) {
  return item?.bookedFor || item?.booked_for || item?.endDate || '';
}

export function getDropoffTime(item) {
  return item?.dropoffTime || item?.dropoff_time || '';
}

export function getRentalDays(item) {
  const explicitDays = Number(item?.quantity ?? item?.booked_days ?? item?.days);
  if (Number.isFinite(explicitDays) && explicitDays > 0) {
    return explicitDays;
  }

  const pickup = getBookedFrom(item);
  const dropoff = getBookedFor(item);
  if (!pickup || !dropoff) return 1;

  const diff = new Date(dropoff) - new Date(pickup);
  const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
  return Math.max(1, days || 1);
}

export function formatRentalDate(value) {
  if (!value) return 'Not selected';
  return new Date(value).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatMoney(value) {
  const amount = Number(value || 0);
  return `$${amount.toFixed(2)}`;
}

export function getRentalLineTotal(item) {
  return Number(item?.product?.price || 0) * getRentalDays(item);
}

export function buildDefaultBookingPayload(productId) {
  const bookedFrom = getTomorrowDate();
  const bookedFor = getDefaultDropoffDate(bookedFrom);

  return {
    productId,
    quantity: 1,
    bookedFrom,
    bookedFor,
    dropoffTime: '10:00',
  };
}
